import { MapPin, ChevronDown } from 'lucide-react';
import { useStandort } from './use-standort';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { Button } from '../ui/button';
import { cn } from '../../lib/utils';

/**
 * Prominenter Kontext-Indikator im Standort-Admin-Bereich.
 * Zeigt den aktiven Standort und erlaubt direkt den Wechsel — damit
 * niemand aus Versehen im falschen Standort konfiguriert.
 */
export const StandortAdminBanner = ({ className }: { className?: string }) => {
  const { selectedStandort, standorte, setSelectedStandortId } = useStandort();

  if (!selectedStandort) {
    return (
      <div className={cn(
        'mb-4 flex items-center gap-3 rounded-lg border border-amber-500/40 bg-amber-500/10 px-4 py-3 text-sm text-amber-700 dark:text-amber-300',
        className,
      )}>
        <MapPin className="h-4 w-4 shrink-0" />
        <span>Kein Standort ausgewählt — bitte oben einen Standort wählen.</span>
      </div>
    );
  }

  return (
    <div className={cn(
      'mb-4 flex flex-wrap items-center gap-3 rounded-lg border border-primary/30 bg-primary/8 px-4 py-3 text-sm',
      className,
    )}>
      <MapPin className="h-4 w-4 shrink-0 text-primary" />
      <div className="flex-1 min-w-0">
        <span className="text-muted-foreground">Du konfigurierst Standort</span>{' '}
        <span className="font-semibold text-foreground">{selectedStandort.name}</span>
      </div>
      {standorte.length > 1 && (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="outline" size="sm" className="gap-1.5">
              Standort wechseln
              <ChevronDown className="h-3.5 w-3.5" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-56">
            <DropdownMenuLabel>Standort wechseln</DropdownMenuLabel>
            <DropdownMenuSeparator />
            {standorte.map((s) => (
              <DropdownMenuItem
                key={s.id}
                onClick={() => setSelectedStandortId(s.id)}
                className={cn(s.id === selectedStandort.id && 'bg-accent/60 font-medium')}
              >
                {s.name}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      )}
    </div>
  );
};
